import { render, staticRenderFns } from "./AddAndEdit.vue?vue&type=template&id=76cf2650&scoped=true"
import script from "./AddAndEdit.vue?vue&type=script&lang=js"
export * from "./AddAndEdit.vue?vue&type=script&lang=js"
import style0 from "./AddAndEdit.vue?vue&type=style&index=0&id=76cf2650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf2650",
  null
  
)

export default component.exports